export const calculateLifeStatus = (startDate: string, expirationMonths: number): 'success' | 'warning' | 'error' => {
  const start = new Date(startDate)
  const current = new Date()
  const totalDays = expirationMonths * 30 // Convertir meses a días
  const elapsedDays = Math.floor((current.getTime() - start.getTime()) / (1000 * 60 * 60 * 24))
  const remainingPercentage = ((totalDays - elapsedDays) / totalDays) * 100

  if (remainingPercentage > 50) return 'success'
  if (remainingPercentage >= 25) return 'warning'
  return 'error'
}
